import type { RendererPlugin } from './renderer.js'
import notch from './renderers/notch.js'
import label from './renderers/label.js'
import marker from './renderers/marker.js'
import loop from './renderers/loop.js'

export const plugins: RendererPlugin[] = [notch, label, marker, loop]

export const loopPlugins: RendererPlugin[] = [loop]
